import React, { useState } from 'react';

import './dropdown.organization.scss';
import GraphQlClient from '../../services/graphql';
import {useTranslation} from "react-i18next";
import {DropDownLog} from "../../services/interactions/elements/dropdown";

function DropdownOrganization({ options, value, onChange, onClick, currentUser, onLogout }) {
    const [isOpen, setOpen] = useState(false);
    const {t}= useTranslation(['menu'])
    const toggleOpen = () => {
        if (onClick) {
            onClick(!isOpen);
        }
        setOpen(!isOpen);
    }

    const logout = () => {
        onLogout();
        GraphQlClient.logout(true);
    }

    return (
        <div id="_dropdownOrgContainer" className={`${isOpen ? 'open' : ''}`}>
            {
                isOpen ? <div className="_dropdownOverlay" onClick={toggleOpen}></div> : ''
            }
            <div className="orgSelect" onClick={toggleOpen}>
                <img className="orgAvatar" alt="Organization Logo" src={value.logoUrl || 'https://secureservercdn.net/198.71.233.68/v6w.28f.myftpupload.com/wp-content/themes/cherish-health-theme/assets/imgs/loader-icon.2140e6671bc0a3820fc7d7bee725c3a0.png'} />
                <p>{value.name}</p>
                <i className="material-icons">
                    keyboard_arrow_down
                </i>
            </div>
            <div className="_options">
                {
                    options.map((option, index) => {
                        const selected = option._id === (!!value && value._id ? value._id : false);
                        return (
                            <div className={`_option ${selected ? 'selected' : ''}`} onClick={() => onChange(option)} key={index}>
                                <img className="orgAvatar" alt="Organization Logo" src={option.logoUrl || 'https://secureservercdn.net/198.71.233.68/v6w.28f.myftpupload.com/wp-content/themes/cherish-health-theme/assets/imgs/loader-icon.2140e6671bc0a3820fc7d7bee725c3a0.png'} />
                                <p>
                                    {option.name}
                                </p>
                            </div>
                        )
                    })
                }
                <div className="_profile">
                    <p>{currentUser.bio.firstname} {currentUser.bio.lastname}</p>
                    <p className="email">{currentUser.email}</p>
                </div>
                <div className="_signout" onClick={logout}>
                    <p>
                        {t('sign-out')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default DropDownLog(DropdownOrganization);
